/* design wording for image alt text (SEO): shared by the product scripts */
window.plDesignPhrase = window.plDesignPhrase || function (n) { return ({ 'Daisy Dot': 'Daisy Dot gray with white daisy dot design', 'Green Check': 'Green Check sage green gingham check design', 'Meadow': 'Meadow warm tan floral design', 'Petal': 'Petal pink floral design', 'Polka Dot': 'Polka Dot cream polka dot design', 'Red Check': 'Red Check coral red gingham check design', 'Sprinkles': 'Sprinkles lavender sprinkle design', 'White': 'White solid white design', 'Cosmos': 'Cosmos starry galaxy design', 'Cream': 'Cream solid design', 'Dream': 'Dream pastel sunset design', 'Garden': 'Garden green floral design', 'Navy': 'Navy solid blue design', 'Olive': 'Olive solid green design', 'Seaside Cabana': 'Seaside Cabana blue stripe design', 'Sienna': 'Sienna terracotta red design', 'Sky': 'Sky solid light blue design', 'Sunset Cabana': 'Sunset Cabana orange stripe design' })[n] || (n + ' design'); };
/* ==========================================================================
   Printed Love 3.0 · Everyday Love Portrait · prototype behaviour
   Same architecture as the blanket and pillow: one module per section,
   init/destroy, shopify:section:load/unload, shared state + document events.
   Header, footer and cart come from ../shared/site.js.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = null;
  function cfg() { if (!CFG) { var el = document.querySelector('[data-pl-product-json]'); CFG = el ? JSON.parse(el.textContent) : { variants: [], designs: [], assets: {} }; } return CFG; }
  function A(k) { return cfg().assets[k] || ''; }
  var SWATCH = { Blush: '#F4C1BE', Sand: '#E3D4CF', Sage: '#A4B08C', Lavender: '#B5AFD1', Yellow: '#FEC96D', Confetti: '#F1F0EC', 'Daisy Dot': '#D8DCDB', 'Green Check': '#C4CAB1', Meadow: '#DDCDB5', Petal: '#EDB0B0', 'Polka Dot': '#EFE8DE', 'Red Check': '#DA9984', Sprinkles: '#B6B0CA', White: '#FFFFFF', Cream: '#F9EBDD', Sienna: '#9D4946', Sky: '#B4DCDF', Olive: '#636B56', Navy: '#243D67', 'Seaside Cabana': '#BCC8C7', 'Sunset Cabana': '#E1B39B', Garden: '#5E6B4E', Dream: '#E7CBA4', Cosmos: '#2D3150' };
  var LIGHT = { Sienna: 1, Olive: 1, Navy: 1, Garden: 1, Cosmos: 1 };
  var DESIGNS = [];
  var SIZES = {
    s12: { price: 85, w: 12, h: 16, label: '12 × 16 in', cm: '30 × 41 cm', use: 'Just right for a side table, stair wall or cozy corner.' },
    s18: { price: 125, w: 18, h: 24, label: '18 × 24 in', cm: '46 × 61 cm', use: 'A versatile size for most walls.' },
    s24: { price: 165, w: 24, h: 32, label: '24 × 32 in', cm: '61 × 81 cm', use: 'A statement size for above a sofa or bed.' }
  };
  function loadConfig() {
    CFG = null;
    DESIGNS = cfg().designs.map(function (d) { return { key: d.name, name: d.name, tile: d.tile, art: d.art, sw: SWATCH[d.name] || '#E8DFD3', light: !!LIGHT[d.name], slug: d.slug }; });
    var byLabel = {}; Object.keys(SIZES).forEach(function (k) { byLabel[SIZES[k].label] = k; });
    cfg().variants.forEach(function (v) { var k = byLabel[v.size]; if (k) SIZES[k].price = v.price / 100; SIZES[k].compare = v.compare ? v.compare / 100 : 0; });
  }
  function design(k) { for (var i = 0; i < DESIGNS.length; i++) if (DESIGNS[i].key === k) return DESIGNS[i]; return DESIGNS[7] || DESIGNS[0]; }
  function variantFor(dn, fr, sk) { var v = cfg().variants, label = SIZES[sk].label; for (var i = 0; i < v.length; i++) if (v[i].design === dn && v[i].frame === fr && v[i].size === label) return v[i]; return null; }

  var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  var state = { design: 'Garden', font: 'classic', frame: 'White', size: 's12', name: '', photo: null, photoName: '', photoUrl: null, uploading: false, preview: false,
                designSet: false, nameSkip: false }; // preselected Garden counts once picked; the name is optional (skippable)
  // Delivery estimate imitates Essential Estimated, same as the blanket and pillow: 2–4 days to make + 3–6 days U.S. transit (confirm for framed canvas)
  var MAKE = [2, 4], SHIP = [3, 6];
  function addDays(from, n) { return new Date(from.getFullYear(), from.getMonth(), from.getDate() + n); }
  var fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  function eta() { var now = new Date(); return fmt.format(addDays(now, MAKE[0] + SHIP[0])) + ' – ' + fmt.format(addDays(now, MAKE[1] + SHIP[1])); }
  function emit() { document.dispatchEvent(new CustomEvent('pl:change', { detail: state })); }
  function scrollToEl(el, block) { el.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: block || 'center' }); }
  function frameLabel() { return state.frame + ' frame'; }
  var FREE_SHIP_MIN = 100;
  function money(n) { return '$' + (Math.round(n * 100) % 100 ? n.toFixed(2) : n); }

  /* shared: paint a framed-art illustration from a design + current state */
  function paintFramed(el, d) {
    var sz = SIZES[state.size];
    el.setAttribute('data-frame', state.frame);
    el.style.setProperty('--ar', sz.w + ' / ' + sz.h);
    el.style.setProperty('--ink', d.light ? '#FCEDDE' : '#342E2A');
    var canvas = el.querySelector('.pl-framed__canvas');
    canvas.style.setProperty('--sw', d.sw); canvas.style.backgroundImage = 'url(' + d.art + ')';
    el.querySelector('.pl-framed__name').textContent = state.name ? (state.font === 'signature' ? state.name : state.name.toUpperCase()) : '';
    var pet = el.querySelector('.pl-framed__pet'), img = pet.querySelector('img'), label = pet.querySelector('span');
    if (state.photo) {
      if (!img) { img = document.createElement('img'); img.alt = ''; pet.insertBefore(img, label); }
      img.src = state.photo; pet.classList.add('has-photo'); label.textContent = 'Rough placement';
    } else { if (img) img.remove(); pet.classList.remove('has-photo'); label.textContent = 'Their portrait'; }
  }
  function paintLive(scope) { scope.querySelectorAll('[data-pl-framed="live"]').forEach(function (el) { paintFramed(el, design(state.design)); }); }

  /* ======================================================================
     MODULE: product (gallery + creation form + sticky bar)
     ====================================================================== */
  function initProduct(root) {
    var ac = new AbortController(), sig = { signal: ac.signal };
    var track = root.querySelector('[data-pl-track]');
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.pl-gallery__thumb'));
    var form = root.querySelector('[data-pl-form]');
    var fileIn = form.querySelector('#pl-photo'), nameIn = form.querySelector('#pl-name');
    var current = 0, raf = 0;

    function go(i, instant) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * current, behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === current)); });
    }
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) { current = i; thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); }); }
      });
    }, { passive: true, signal: ac.signal });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }, sig); });
    root.querySelector('[data-pl-prev]').addEventListener('click', function () { go(current - 1); }, sig);
    root.querySelector('[data-pl-next]').addEventListener('click', function () { go(current + 1); }, sig);

    /* swiping forward on the last photo loops back to the first */
    var swipeX = null;
    track.addEventListener('touchstart', function (e) { swipeX = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true, signal: ac.signal });
    track.addEventListener('touchend', function (e) {
      if (swipeX === null) return;
      var dx = e.changedTouches[0].clientX - swipeX; swipeX = null;
      if (dx < -40 && current === slides.length - 1 && track.scrollLeft >= track.scrollWidth - track.clientWidth - 4) go(0);
    }, { passive: true, signal: ac.signal });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    }, sig);

    function setDesign(key, instant) {
      var d = design(key); state.design = d.key;
      var r = form.querySelector('input[name="design"][value="' + d.key + '"]'); if (r) r.checked = true;
      update();
    }
    function setFrame(f) { state.frame = f; var r = form.querySelector('input[name="frame"][value="' + f + '"]'); if (r) r.checked = true; update(); }
    function setSize(s) { state.size = s; var r = form.querySelector('input[name="size"][value="' + s + '"]'); if (r) r.checked = true; update(); }
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'font') { state.font = t.value; PL.memory.set({ font: t.value }); return update(); }
      if (t.name === 'design') { state.designSet = true; PL.memory.set({ design: t.value }); return setDesign(t.value); }
      if (t.name === 'frame') { state.frameSet = true; return setFrame(t.value); }
      if (t.name === 'size') { state.sizeSet = true; return setSize(t.value); }
      if (t.hasAttribute('data-pl-preview')) { state.preview = t.checked; update(); }
    }, sig);
    nameIn.addEventListener('input', function () { state.name = nameIn.value.trim(); PL.memory.set({ name: state.name || null }); update(); }, sig);
    document.addEventListener('pl:set-design', function (e) { state.designSet = true; PL.memory.set({ design: e.detail }); setDesign(e.detail); }, sig);
    document.addEventListener('pl:set-size', function (e) { state.sizeSet = true; setSize(e.detail); }, sig);
    document.addEventListener('pl:set-frame', function (e) { state.frameSet = true; setFrame(e.detail); }, sig);

    var slot = form.querySelector('[data-pl-upload-slot]'), variantInput = form.querySelector('[data-pl-variant-id]'), photoFrom = 'uploaded';
    function err(show, msg) {
      var el = form.querySelector('[data-pl-err="photo"]');
      if (msg) el.textContent = msg; el.hidden = !show;
      el.closest('.pl-field').classList.toggle('is-invalid', show);
      if (show) fileIn.setAttribute('aria-invalid', 'true'); else fileIn.removeAttribute('aria-invalid');
    }
    function lift() { return slot.querySelector('input.filepond--browser'); }
    function showPhoto(src, name, status) {
      state.photo = src; state.photoName = name;
      form.querySelector('[data-pl-thumb]').src = src;
      form.querySelector('[data-pl-file]').textContent = name;
      form.querySelector('[data-pl-upload-ok]').textContent = status || 'Photo added';
      form.querySelector('[data-pl-upload-empty]').hidden = true;
      form.querySelector('[data-pl-upload-done]').hidden = false;
      err(false);
    }
    function clearPhoto() {
      state.photo = null; state.photoName = ''; state.photoUrl = null; state.uploading = false; state.pendingAdd = false;
      form.querySelector('[data-pl-upload-empty]').hidden = false;
      form.querySelector('[data-pl-upload-done]').hidden = true;
      PL.memory.set({ photo: null, photoName: null, photoFrom: null });
      var carried = form.querySelector('[data-pl-carried]'); if (carried) carried.remove();
      update();
    }
    function openPicker() { var f = lift(); (f || fileIn).click(); }
    form.addEventListener('click', function (e) {
      var lab = e.target.closest('label[for="pl-photo"]'); if (!lab || !lift()) return;
      e.preventDefault(); openPicker();
    }, sig);
    function onPicked(file) {
      if (!file) return;
      if (!/^image\//.test(file.type) && !/\.(heic|heif)$/i.test(file.name)) { err(true, "That file isn't a photo. Try a JPG, PNG or HEIC from your camera roll."); return false; }
      if (state.localUrl) URL.revokeObjectURL(state.localUrl);
      state.localUrl = URL.createObjectURL(file);
      photoFrom = 'uploaded'; state.photoUrl = null; state.uploading = !!lift();
      showPhoto(state.localUrl, file.name, state.uploading ? 'Uploading…' : 'Photo added');
      var carried = form.querySelector('[data-pl-carried]'); if (carried) carried.remove();
      update();
      return true;
    }
    fileIn.addEventListener('change', function () { var f = fileIn.files && fileIn.files[0]; if (!onPicked(f)) fileIn.value = ''; }, sig);
    slot.addEventListener('change', function (e) { if (e.target.matches('input.filepond--browser')) onPicked(e.target.files && e.target.files[0]); }, sig);
    window.addEventListener('upload:added', function (ev) {
      var f = ev.detail; if (!f || !f.url || (f.meta && f.meta.variant === 'thumbnail')) return;
      state.photoUrl = f.url; state.uploading = false; photoFrom = 'uploaded'; if (state.pendingAdd) { state.pendingAdd = false; form.requestSubmit(); }
      if (!state.photo) showPhoto(f.url, f.name || 'Your photo'); else form.querySelector('[data-pl-upload-ok]').textContent = 'Photo added';
      PL.memory.keepPhoto(f.url, f.name || 'Your photo');
      err(false); update();
    }, sig);
    window.addEventListener('upload:removed', function () { if (!state.uploading) clearPhoto(); }, sig);
    /* a photo they added on another product: reuse its file URL, no second upload */
    function useCarried(c) {
      photoFrom = 'reused'; state.photoUrl = c.src; state.uploading = false;
      showPhoto(c.src, c.name);
      PL.memory.carriedNote(fileIn.closest('.pl-field'), c.from);
    }

    function update() {
      var leadLi = root.querySelector('.pl-gallery__slide.is-lead'); if (leadLi) { if (state.photo) leadLi.setAttribute('data-pl-live', ''); else leadLi.removeAttribute('data-pl-live'); } // Charlie's portrait until a photo is added
      document.documentElement.setAttribute('data-pl-font', state.font);
      var d = design(state.design), sz = SIZES[state.size], vv = variantFor(d.name, state.frame, state.size);
      if (vv) { variantInput.value = vv.id; try { var u = new URL(location.href); u.searchParams.set('variant', vv.id); history.replaceState(null, '', u); } catch (e) {} }
      root.querySelectorAll('[data-pl-size-price-opt]').forEach(function (el) { el.textContent = money(SIZES[el.getAttribute('data-pl-size-price-opt')].price); });
      state.designName = d.name; // e.g. "Blue Stripe" for the shared Better together caption
      root.querySelector('[data-pl-design-name]').textContent = d.name;
      root.querySelector('[data-pl-frame-name]').textContent = state.frame;
      renderGallery(root, d);
      var summary = [d.name, frameLabel(), sz.label]; if (state.name) summary.push(state.name); summary.push({ classic: 'Classic font', signature: 'Signature font', playful: 'Playful font' }[state.font]);
      root.querySelector('[data-pl-summary-text]').textContent = summary.join(' · ');
      var st = root.querySelector('[data-pl-summary-thumb]');
      if (state.photo) { st.style.backgroundImage = 'url(' + state.photo + ')'; st.style.backgroundSize = 'cover'; }
      else { st.style.setProperty('--sw', d.sw); st.style.backgroundImage = 'url(' + d.tile + ')'; st.style.backgroundSize = 'cover'; }
      paintLive(root);
      root.querySelector('[data-pl-price]').textContent = money(sz.price);
      var wasEl = root.querySelector('[data-pl-was]');
      if (wasEl) { wasEl.hidden = !(sz.compare > sz.price); if (!wasEl.hidden) root.querySelector('[data-pl-was-val]').textContent = money(sz.compare); }
      root.querySelector('[data-pl-atc-price]').textContent = money(sz.price);
      var ship = root.querySelector('[data-pl-ship-line]'), free = sz.price >= FREE_SHIP_MIN;
      ship.textContent = free ? 'This portrait ships free.' : 'Shipping $9.99, free on orders over $99.';
      ship.classList.toggle('is-free', free);
      // next step: photo, then size (the wall guide below), then add to cart right there
      var n = nextStep();
      document.querySelectorAll('[data-pl-nextstep-label]').forEach(function (l) { l.textContent = n.label; });
      document.querySelectorAll('[data-pl-nextstep]').forEach(function (b) { b.classList.toggle('is-photo', n.key === 'photo'); });
      var tgt = n.key === 'frame' ? frameBox() : n.key === 'size' ? document.querySelector('#pl-wall') : n.key === 'design' ? designBox() : n.key === 'name' ? nameIn : null;
      var etaEl = root.querySelector('[data-pl-eta]'); if (etaEl) etaEl.textContent = eta();
      document.querySelectorAll('[data-pl-strip-label]').forEach(function (l) { l.textContent = started() ? 'Finish your portrait' : 'Create your portrait'; });
      document.querySelectorAll('[data-pl-nextstep]').forEach(function (b) {
        var down = !!tgt && (b.compareDocumentPosition(tgt) & Node.DOCUMENT_POSITION_FOLLOWING); // arrow points where it will take them
        b.classList.toggle('is-down', down); b.classList.toggle('is-cart', n.key === 'cart');
        var card = b.parentNode, skip = card.querySelector(':scope > [data-pl-skipname]'); // optional name: a quiet skip beside the button
        if (n.key === 'name' && !skip) { skip = document.createElement('button'); skip.type = 'button'; skip.className = 'pl-skipname'; skip.setAttribute('data-pl-skipname', ''); skip.textContent = 'No name, thanks'; card.appendChild(skip); }
        if (skip) skip.hidden = n.key !== 'name';
      });
      var sb = document.querySelector('[data-pl-sticky-btn]'); if (sb) sb.textContent = state.photo ? 'Add to cart' : 'Add your photo';
      var sticky = document.querySelector('[data-pl-sticky-text]'); if (sticky) sticky.textContent = d.name + ' · ' + state.frame + ' · ' + sz.label;
      emit();
    }

    /* order: photo, design, frame, size, their name (optional, skippable), then Add to cart */
    function frameBox() { var r = form.querySelector('input[name="frame"]'); return r ? r.closest('fieldset') : form; }
    function designBox() { return document.querySelector('[data-pl-swatches]') || form; }
    function nextStep() {
      if (!state.designSet) return { key: 'design', label: 'Next: choose your design' };
      if (!state.frameSet) return { key: 'frame', label: 'Next: choose your frame' };
      if (!state.photo) return { key: 'photo', label: 'Add your photo' };
      if (!state.name && !state.nameSkip) return { key: 'name', label: 'Next: add their name' };
      if (!state.sizeSet) return { key: 'size', label: 'Next: confirm your size' };
      return { key: 'cart', label: 'Add to cart · ' + money(SIZES[state.size].price) };
    }
    function started() { return !!(state.designSet || state.frameSet || state.sizeSet || state.photo || state.name); }
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-pl-skipname]')) return; state.nameSkip = true; update(); }, sig);
    /* slim button before the FAQ: not started -> the very top; started -> the card holding their next step */
    document.addEventListener('click', function (e) {
      var st = e.target.closest('[data-pl-strip]'); if (!st) return;
      e.preventDefault();
      // always back up to the main personalization box at the top of the page
      scrollToEl(document.querySelector('#pl-buy [data-pl-form]') || document.querySelector('#pl-buy'), 'start');
    }, sig);
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pl-nextstep]'); if (!a) return;
      e.preventDefault();
      var n = nextStep(), target, focusEl;
      if (n.key === 'cart') { form.requestSubmit(); return; }
      if (n.key === 'photo') { openPicker(); return; } // pick the photo right here; the button then moves on to the next step
      else if (n.key === 'frame') { target = frameBox(); focusEl = target.querySelector('input:checked'); }
      else if (n.key === 'design') { target = designBox(); focusEl = target.querySelector('input:checked'); }
      else if (n.key === 'name') { target = nameIn.closest('.pl-field'); focusEl = nameIn; }
      else { target = document.querySelector('#pl-wall .pl-size__body') || form.querySelector('input[name="size"]').closest('fieldset'); focusEl = document.querySelector('#pl-wall [role="tab"][aria-selected="true"]'); }
      scrollToEl(target, 'center'); if (focusEl) focusEl.focus({ preventScroll: true });
      target.classList.remove('is-next'); void target.offsetWidth; target.classList.add('is-next');
    }, sig);
    /* The main Add to cart button goes through our own submit handler, the same way the sticky bar and the "Next" cards do.
       Upload-Lift otherwise blocks the click when the photo came from another product (no upload on this page) and says nothing. */
    window.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-pl-atc]'); if (!b || !form.contains(b)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      form.requestSubmit();
    }, { capture: true, signal: ac.signal });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!state.photo) { err(true, 'Add a photo of your pet to continue.'); scrollToEl(fileIn.closest('.pl-field')); fileIn.focus({ preventScroll: true }); return; }
      if (state.uploading) { state.pendingAdd = true; err(true, 'Your photo is still uploading. One moment.'); return; }
      if (!state.photoUrl) { err(true, "We couldn't save your photo. Please choose it again."); return; }
      var v = variantFor(state.design, state.frame, state.size); if (!v) return;
      var fd = new FormData(form);
      fd.set('id', v.id); fd.set('quantity', '1');
      if (!fd.get('properties[Pet Photo]')) fd.set('properties[Pet Photo]', state.photoUrl); // a reused photo has no widget field
      fd.set('properties[_photo_from]', photoFrom); fd.set('properties[_set_id]', PL.setId());
      if (state.name) fd.set('properties[Pet Name]', state.font === 'playful' ? state.name.toUpperCase() : state.name); else fd.delete('properties[Pet Name]');
      fd.delete('font'); fd.set('properties[Font]', fontLabels[state.font]);
      if (!state.preview) fd.delete('properties[Design preview]');
      var btn = form.querySelector('[data-pl-atc]'); btn.disabled = true;
      window.PLCart.addForm(fd).catch(function (er) { err(true, er.message || 'Something went wrong. Please try again.'); }).then(function () { btn.disabled = false; });
    }, sig);
    document.addEventListener('pl:pick-photo', openPicker, sig);

    /* sticky bar (phones), position check so jumps can't skip it */
    var bar = document.querySelector('[data-pl-sticky]'), atc = form.querySelector('[data-pl-atc]'), closeSec = document.querySelector('[data-pl-site="set"]'), barRaf = 0;
    function syncBar() {
      barRaf = 0;
      var passed = atc.getBoundingClientRect().bottom < 0;
      var c = closeSec ? closeSec.getBoundingClientRect() : null;
      var on = passed && !(c && c.top < innerHeight && c.bottom > 0) && innerWidth < 990;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', String(!on));
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.documentElement.classList.toggle('pl-sticky-on', on);
    }
    function queueBar() { if (!barRaf) barRaf = requestAnimationFrame(syncBar); }
    addEventListener('scroll', queueBar, { passive: true, signal: ac.signal });
    addEventListener('resize', queueBar, sig);
    bar.querySelector('[data-pl-sticky-btn]').addEventListener('click', function () { if (!state.photo) openPicker(); else form.requestSubmit(); }, sig); // no photo yet: the bar asks for it
    syncBar();

    // Start from what they're making: ?design= from a link, else the background they last chose on any product
    var sd = PL.memory.startDesign(); if (sd) { state.design = sd; state.designSet = true; }
    var fontLabels = { classic: 'Classic', signature: 'Signature', playful: 'Playful' };
    var mf = PL.memory.get().font; if (mf && fontLabels[mf]) { state.font = mf; var fr = form.querySelector('input[name="font"][value="' + mf + '"]'); if (fr) fr.checked = true; }
    var mem = PL.memory.get();
    if (mem.name && !nameIn.value) { nameIn.value = mem.name; state.name = mem.name; }
    var carried = !state.photo && PL.memory.carriedPhoto(); if (carried) useCarried(carried);
    setDesign(state.design, true);
    return function () { ac.abort(); cancelAnimationFrame(raf); cancelAnimationFrame(barRaf); bar.classList.remove('is-on'); document.documentElement.classList.remove('pl-sticky-on'); };
  }

  /* ======================================================================
     MODULE: journey — frame one becomes the shopper's own photo
     ====================================================================== */
  function initJourney() { return function () {}; } // always an example now (like the blanket); no upload here


  /* ======================================================================
     MODULE: world — the background collection; tapping sets the buy box
     ====================================================================== */
  var DARK = ['Sienna', 'Olive', 'Navy', 'Garden', 'Cosmos']; // name in light ink on these
  function initWorld(root) {
    var ac = new AbortController(), sig = { signal: ac.signal };
    var rail = root.querySelector('[data-pl-world-rail]'), stage = root.querySelector('[data-pl-world-stage]'), fl = root.querySelector('[data-pl-world-frames]');
    var canvas = root.querySelector('[data-pl-wp-canvas]'), frameImgs = root.querySelectorAll('[data-pl-wp-frame]'), pet = root.querySelector('[data-pl-wp-pet]'), ph = root.querySelector('[data-pl-wp-ph]');
    var nameEl = root.querySelector('[data-pl-wp-name]');
    var o = OPENING.flat; canvas.style.cssText = 'left:' + o[0] + '%;top:' + o[1] + '%;width:' + o[2] + '%;height:' + o[3] + '%';
    root.querySelector('[data-pl-wp-pick]').addEventListener('click', function () { document.dispatchEvent(new CustomEvent('pl:pick-photo')); }, sig);
    var wchg = root.querySelector('[data-pl-lead-change]'); if (wchg) wchg.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('pl:pick-photo')); }, sig);
    nameEl.addEventListener('input', function () { var f = document.querySelector('#pl-name'); if (!f) return; f.value = nameEl.value; f.dispatchEvent(new Event('input', { bubbles: true })); }, sig);
    nameEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); nameEl.blur(); } }, sig);
    function toast(text) { // phones: the big preview may be off-screen, so pop a short confirmation where they are
      var t = root.querySelector('[data-pl-world-toast]'), r = stage.getBoundingClientRect();
      if (!t || (r.top < innerHeight && r.bottom > 0)) return;
      t.querySelector('[data-pl-world-toast-name]').textContent = text;
      t.hidden = false; t.classList.remove('is-on'); void t.offsetWidth; t.classList.add('is-on');
      clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
    }
    if (rail) rail.innerHTML = '';
    var buttons = !rail ? [] : DESIGNS.map(function (d) { // same swatch rail as the blanket
      var li = document.createElement('li'), b = document.createElement('button');
      b.type = 'button'; b.className = 'pl-look'; b.setAttribute('aria-pressed', 'false'); b.setAttribute('data-design', d.key);
      b.innerHTML = '<span class="pl-look__tile" style="background-image:url(' + d.tile + ');background-size:cover;background-position:center"></span><span>' + d.name + '</span>';
      b.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('pl:set-design', { detail: d.key })); toast(d.name); }, sig);
      li.appendChild(b); rail.appendChild(li); return b;
    });
    if (fl) fl.innerHTML = '';
    var frames = !fl ? [] : ['Black', 'White', 'Natural'].map(function (f) {
      var li = document.createElement('li'), b = document.createElement('button');
      b.type = 'button'; b.className = 'pl-wframe'; b.setAttribute('aria-pressed', 'false'); b.dataset.frame = f;
      b.innerHTML = '<img src="' + A('frame-flat-' + f.toLowerCase()) + '" alt="" loading="lazy"><span>' + f + '</span>';
      b.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('pl:set-frame', { detail: f })); toast(f + ' frame'); }, sig);
      li.appendChild(b); fl.appendChild(li); return b;
    });
    function onState() {
      var d = design(state.design), k = d.key + '|' + state.frame;
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-design') === d.key)); });
      frames.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.frame === state.frame)); });
      if (stage.dataset.k !== k) {
        stage.dataset.k = k;
        frameImgs.forEach(function (im) { im.hidden = im.getAttribute('data-pl-wp-frame') !== state.frame; }); // all three preloaded: no blank flash
        canvas.style.backgroundImage = 'url(' + d.art + ')';
      }
      canvas.style.setProperty('--ink', DARK.indexOf(d.key) >= 0 ? '#FCEDDE' : '#342E2A');
      if (document.activeElement !== nameEl) nameEl.value = state.name || '';
      nameEl.classList.toggle('is-empty', !state.name);
      var img = pet.querySelector('img');
      if (state.photo) {
        if (!img) { img = document.createElement('img'); img.className = 'pl-illo__photo'; img.alt = ''; pet.appendChild(img); }
        if (img.getAttribute('src') !== state.photo) img.src = state.photo;
        pet.classList.add('has-photo'); ph.hidden = true;
      } else { if (img) img.remove(); pet.classList.remove('has-photo'); ph.hidden = false; }
      root.querySelector('[data-pl-wp-paint]').hidden = !state.photo;
      root.querySelector('[data-pl-wp-label]').innerHTML = '<span class="pl-looks__dlabel">Selected design</span> <b>' + d.name + '</b>';
      var wkd = root.querySelector('[data-pl-wk-design]'); if (wkd) wkd.textContent = d.name;
      var wkf = root.querySelector('[data-pl-wk-frame]'); if (wkf) wkf.textContent = state.frame;
      var wst = root.querySelector('[data-pl-world-status]'); if (wst) wst.textContent = d.name + ' with a ' + state.frame.toLowerCase() + ' frame';
      var wch = root.querySelector('[data-pl-lead-change]'); if (wch) wch.hidden = !state.photo;
    }
    document.addEventListener('pl:change', onState, sig); onState();
    return function () { ac.abort(); };
  }

  /* ======================================================================
     MODULE: wall — size guide, elevation view, one scale (SVG units = inches)
     ====================================================================== */
  var ORDER_SIZES = ['s12', 's18', 's24'];
  // Charlie's real printed design for a background (crops of the blanket variant mockups, shared with "Better together")
  function setArt(d) { return A('print-' + d.slug); } // owner's flat Printify prints
  // A real frame photo with Charlie's print placed in its canvas opening (Printify frame renders, 2026-10-01).
  // flat = straight-on product shot; room = the same frame on a wall above a console.
  function angleShot(d, frame) { return A('angle-' + d.slug + '-' + (frame || 'White').toLowerCase()); }
  /* The product gallery: every shot follows the chosen background and frame (flat front, on the wall, angled, the print itself) */
  function renderGallery(root, d) {
    var f = state.frame, fl = f.toLowerCase(), k = d.key + '|' + f;
    var track = root.querySelector('[data-pl-track]'); if (track.dataset.k === k) return; track.dataset.k = k;
    var alt = 'Everyday Love Portrait ' + d.name + ' ' + fl + ' frame Printed Love';
    var html = {
      flat: framedMock(d, f),
      room: framedMock(d, f, 'room'),
      angle: '<img src="' + angleShot(d, f) + '" alt="" width="900" height="900" loading="lazy">',
      print: '<img src="' + setArt(d) + '" alt="" loading="lazy">'
    };
    var label = { flat: alt + ', front view', room: alt + ', hung above a console', angle: alt + ', framed canvas mockup', print: 'The ' + d.name + ' print on its own, up close' };
    root.querySelectorAll('[data-pl-gal]').forEach(function (el) {
      var kind = el.getAttribute('data-pl-gal');
      if (el.tagName === 'LI') { var keep = el.querySelector(':scope > .pl-lead-world'); el.innerHTML = '<div class="pl-gal" role="img" aria-label="' + label[kind] + '">' + html[kind] + '</div>'; if (keep) el.appendChild(keep); }
      else el.innerHTML = html[kind];
    });
  }
  var OPENING = { flat: [20.2, 12.75, 59.6, 74.6], room: [36.2, 29.5, 24.7, 31.0] };
  function framedMock(d, frame, kind) {
    kind = kind || 'flat'; var o = OPENING[kind], f = (frame || 'White').toLowerCase();
    return '<span class="pl-mock pl-mock--' + kind + '"><img class="pl-mock__frame" src="' + A('frame-' + kind + '-' + f) + '" alt="" loading="lazy">' +
      '<img class="pl-mock__art" src="' + setArt(d) + '" alt="" loading="lazy" style="left:' + o[0] + '%;top:' + o[1] + '%;width:' + o[2] + '%;height:' + o[3] + '%"></span>';
  }
  function wallScene(active, d) {
    var W = 100, H = 80, FLOOR = 78, BASE = 38, x = 14, GAP = 10, s = '', defs = '';
    s += '<rect class="wall" width="' + W + '" height="' + H + '"/><rect class="floor2" y="' + FLOOR + '" width="' + W + '" height="' + (H - FLOOR) + '"/><rect class="skirting" y="' + (FLOOR - 2.5) + '" width="' + W + '" height="2.5"/>';
    // sofa, 84 in wide: back 34 in, seat 18 in, arms 24 in
    s += '<rect class="furn-2" x="10" y="' + (FLOOR - 34) + '" width="80" height="18" rx="3"/>';
    s += '<rect class="furn" x="8" y="' + (FLOOR - 18) + '" width="84" height="15" rx="2.5"/>';
    s += '<rect class="furn-2" x="6" y="' + (FLOOR - 24) + '" width="8" height="21" rx="3"/><rect class="furn-2" x="86" y="' + (FLOOR - 24) + '" width="8" height="21" rx="3"/>';
    s += '<rect class="furn-3" x="15" y="' + (FLOOR - 18) + '" width="34.5" height="5" rx="2"/><rect class="furn-3" x="50.5" y="' + (FLOOR - 18) + '" width="34.5" height="5" rx="2"/>';
    s += '<rect class="furn-2" x="12" y="' + (FLOOR - 3) + '" width="2" height="3"/><rect class="furn-2" x="86" y="' + (FLOOR - 3) + '" width="2" height="3"/>';
    var frameStroke = state.frame === 'Black' ? '#24211F' : state.frame === 'Natural' ? '#C9AB80' : '#FBFAF7';
    ORDER_SIZES.forEach(function (k) {
      var sz = SIZES[k], y = BASE - sz.h, on = k === active;
      if (on) {
        defs += '<pattern id="pl-wall-art" patternContentUnits="objectBoundingBox" width="1" height="1"><image href="' + d.art + '" width="1" height="1" preserveAspectRatio="xMidYMid slice"/></pattern>';
        s += '<rect class="canvas-on" x="' + x + '" y="' + y + '" width="' + sz.w + '" height="' + sz.h + '" fill="url(#pl-wall-art)" stroke="' + frameStroke + '"/>';
        s += '<rect x="' + (x - .5) + '" y="' + (y - .5) + '" width="' + (sz.w + 1) + '" height="' + (sz.h + 1) + '" fill="none" stroke="rgb(52 46 42 / .25)" stroke-width=".2"/>';
      } else {
        s += '<rect class="canvas-off" x="' + x + '" y="' + y + '" width="' + sz.w + '" height="' + sz.h + '"/>';
      }
      s += '<text class="wlbl' + (on ? ' wlbl-on' : '') + '" x="' + (x + sz.w / 2) + '" y="' + (BASE + 3.6) + '" text-anchor="middle">' + sz.w + '×' + sz.h + '</text>';
      x += sz.w + GAP;
    });
    s += '<text class="wcap" x="3" y="5">WALL ABOVE AN 84 IN SOFA · TO SCALE</text>';
    var sz = SIZES[active];
    var title = 'All three portrait sizes hung above an 84 inch sofa, to scale. Highlighted: ' + sz.label + ' in ' + d.name + ' with a ' + state.frame.toLowerCase() + ' frame.';
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="' + title + '"><title>' + title + '</title><defs>' + defs + '</defs>' + s + '</svg>';
  }
  function initWall(root) {
    var ac = new AbortController(), sig = { signal: ac.signal };
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panel = root.querySelector('[data-pl-wall-panel]'), sceneEl = root.querySelector('[data-pl-wall-scene]');
    var viewing = state.size, drawn = '';
    function show(size, focus) {
      viewing = size; var sz = SIZES[size], d = design(state.design);
      tabs.forEach(function (t) {
        var on = t.dataset.size === size;
        t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
        if (on) { panel.setAttribute('aria-labelledby', t.id); if (focus) t.focus(); }
      });
      var key = size + '|' + state.design + '|' + state.frame;
      if (key !== drawn) { sceneEl.innerHTML = wallScene(size, d); drawn = key; }
      root.querySelector('[data-pl-wall-dim]').innerHTML = sz.label + ' <span>' + sz.cm + '</span>';
      root.querySelector('[data-pl-wall-use]').textContent = sz.use;
      root.querySelector('[data-pl-wall-price]').textContent = money(sz.price);
      var chosen = viewing === state.size && state.sizeSet;
      root.querySelector('[data-pl-wall-choose]').hidden = chosen;
      root.querySelector('[data-pl-wall-chosen]').hidden = !chosen;
      root.querySelector('[data-pl-wall-chosen-name]').textContent = sz.label;
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t.dataset.size); }, sig);
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight') n = (i + 1) % tabs.length;
        if (k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (k === 'Home') n = 0;
        if (k === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); show(tabs[n].dataset.size, true); }
      }, sig);
    });
    root.querySelector('[data-pl-wall-choose]').addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('pl:set-size', { detail: viewing }));
      root.querySelector('[data-pl-wall-chosen]').focus();
    }, sig);
    var lastSize = state.size;
    document.addEventListener('pl:change', function () {
      if (state.size !== lastSize) { lastSize = state.size; show(lastSize); } else show(viewing);
    }, sig);
    show(state.size);
    return function () { ac.abort(); };
  }

  /* ======================================================================
     MODULE: preview — the proof email illustration follows the portrait
     ====================================================================== */
  function initPreview(root) {
    var ac = new AbortController();
    function onState() {
      var d = design(state.design), box = root.querySelector('[data-pl-mail-art]'), k = d.key + '|' + state.frame;
      if (box.dataset.k !== k) { box.dataset.k = k; box.innerHTML = framedMock(d, state.frame); }
      root.querySelector('[data-pl-mail-subject]').textContent = (state.name || 'Charlie') + '\u2019s portrait is ready to look over';
      root.querySelector('[data-pl-mail-meta]').textContent = d.name + ' \u00b7 ' + state.frame + ' frame \u00b7 ' + SIZES[state.size].label;
      root.querySelector('[data-pl-mail-line]').textContent = 'Take a look before we print. If you\'d like anything adjusted, just reply and let us know.';
    }
    document.addEventListener('pl:change', onState, { signal: ac.signal }); onState();
    return function () { ac.abort(); };
  }

  /* ---------------- registry + Shopify editor lifecycle ---------------- */
  /* ======================================================================
     MODULE: frames — show the three frames with their design, tap to choose
     ====================================================================== */
  var FRAMES = [
    { name: 'Black', color: '#24211F', note: 'Crisp and graphic' },
    { name: 'White', color: '#F7F5F1', note: 'Light and airy' },
    { name: 'Natural', color: '#C9AB80', note: 'Warm pinewood' }
  ];


  function initHome(root) {
    var ac = new AbortController(), box = root.querySelector('[data-pl-home-room]');
    function render() { var d = design(state.design), k = d.key + '|' + state.frame; if (box && box.dataset.k !== k) { box.dataset.k = k; box.innerHTML = framedMock(d, state.frame, 'room'); } }
    document.addEventListener('pl:change', render, { signal: ac.signal }); render();
    return function () { ac.abort(); };
  }

  var MODULES = { journey: initJourney, home: initHome, world: initWorld, wall: initWall, product: initProduct }; // "Better together" is shared
  var ORDER = ['journey', 'world', 'home', 'wall', 'product']; // listeners mount before product emits
  var live = new Map();
  function mount(el) { var fn = MODULES[el.getAttribute('data-pl-section')]; if (fn && !live.has(el)) live.set(el, fn(el)); }
  function unmount(el) { var d = live.get(el); if (d) { d(); live.delete(el); } }
  function scan(scope) {
    var els = [];
    if (scope.matches && scope.matches('[data-pl-section]')) els.push(scope);
    scope.querySelectorAll('[data-pl-section]').forEach(function (el) { els.push(el); });
    els.sort(function (a, b) { return ORDER.indexOf(a.getAttribute('data-pl-section')) - ORDER.indexOf(b.getAttribute('data-pl-section')); });
    els.forEach(mount);
  }
  document.addEventListener('shopify:section:load', function (e) { loadConfig(); scan(e.target); emit(); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-pl-section]').forEach(unmount);
    if (e.target.matches('[data-pl-section]')) unmount(e.target);
  });
  loadConfig(); (cfg().designs.length) && scan(document);
  addEventListener('pagehide', function () { if (state.localUrl) URL.revokeObjectURL(state.localUrl); });
})();
